import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";
import Swal from 'sweetalert2';

const PrPurchaseReqviewsingle = () => {
   useAuthRedirect();
    const {priorNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [indentView, setIndentView] = useState({});
  const [indentView1, setIndentView1] = useState({});
  const [data, setData] = useState([]);


  

useEffect(() => {
  const fetchAllPRDetails = async () => {
    Swal.fire({
      title: "Loading PR Purchase Details...",
      html: `
        <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
        </div>
        <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch the data...</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        if (!document.getElementById("progressBarStyle")) {
          const style = document.createElement("style");
          style.id = "progressBarStyle";
          style.innerHTML = `
            @keyframes progressBar {
              0% { width: 0% }
              50% { width: 100% }
              100% { width: 0% }
            }
          `;
          document.head.appendChild(style);
        }
      }
    });

    try {
      const [headerRes, detailsRes] = await Promise.all([
        axios.get(`https://rfs2.infraconsoft.net.in/api/prPurchase_detailsHeader?priorNo=${priorNo}`),
        axios.get(`https://rfs2.infraconsoft.net.in/api/prPurchase_detailsHeader1?priorNo=${priorNo}&branch=${branch}`)
      ]);

      // Header
      if (headerRes.data?.headerDetails?.length > 0) {
        const item = headerRes.data.headerDetails[0];
        setIndentView({
          prHeader_number: item.prHeader_number || "N/A",
          branchmaster_name: item.branchmaster_name || "N/A",
          prHeader_hod: item.prHeader_hod || "N/A",
          prHeader_remarks: item.prHeader_remarks || "N/A",
          prHeader_date: item.prHeader_date || "N/A",
          prHeader_headMaterial: item.prHeader_headMaterial || "N/A"
        });
      }

      // Supplier Details
      if (detailsRes.data?.headerDetails1?.length > 0) {
        const item1 = detailsRes.data.headerDetails1[0];
        setIndentView1({
          PrDetail_supplierCode: item1.PrDetail_supplierCode || "N/A",
          supplierMaster_name: item1.supplierMaster_name || "N/A"
        });
        setData(detailsRes.data.headerDetails1);
      }

    } catch (error) {
      console.error("Error fetching PR Purchase data:", error);
    } finally {
      Swal.close();
    }
  };

  fetchAllPRDetails();
}, [priorNo, branch]);





  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                    <h2 className="add-txt">Prior Purchase Requisition - View</h2>
                    <Link to='/inventory/prview'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
          <div className="form-row">
              <div className="form-group">
                <label>Prior Pr Req No :</label>
                <input type="text" name="indentNo" value={indentView.prHeader_number} readOnly/>
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input
  type="text"
  name="endhrs"
  value={indentView.prHeader_date ? new Date(indentView.prHeader_date).toISOString().split("T")[0] : ""}
 readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="indentNo" value={indentView1.PrDetail_supplierCode} readOnly/>
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" value={indentView1.supplierMaster_name} name="user"  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Branch :</label>
                <input type="text" name="indentNo" value={indentView.branchmaster_name} readOnly/>
              </div>
              <div className="form-group">
                <label>HOD :</label>
                <input type="text" value={indentView.prHeader_hod} name="user"  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={indentView.prHeader_remarks} name="remarks" readOnly />
              </div>
              <div className="form-group">
                <label>Indenter</label>
                <input type="text" value={indentView.prHeader_headMaterial} name="remarks" readOnly />
              </div>
            </div>


            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Amount</th>
                    <th>Due Date</th>
                  </tr>
                </thead>
                <tbody>
  {data.length > 0 ? (
    data.map((item, index) => {
      const total = item.prDetail_price * item.prDetail_quantity;

      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.PrDetail_itemCode}</td>
          <td>{item.itemMaster_name}</td>
          <td>{item.itemMaster_uom}</td>
          <td>{item.prDetail_quantity}</td>
          <td>{item.prDetail_price}</td>
          <td>{total.toFixed(2)}</td>
          <td>{new Date(item.prDetail_duedate).toLocaleDateString("en-GB")}</td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="9">No items</td>
    </tr>
  )}
</tbody>

              </table>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default PrPurchaseReqviewsingle;
